export class AppPageRelationships {
    relationship: Array<Relationship> = new Array<Relationship>();
}
export class Relationship {
    /**
     * 关系类型
     */
    relationshipType: number;
    /**
     * 为当前列表获取数据时提供前至参数的元素name属性（也可理解为关联的父级字段），如果前至参数
     * 有多个，则可以有多个Relationship元素
     */
    sourceParam: string;
    /**
     * 表示参数字段名的转换名称，用于弹出框View对应的字段名称，如未提供，则默认为sourceParam字段名称
     * 【弹出框的查询条件字段名称应该为弹出框对象的View字段名称】
     */
    convertGridPickerFieldName: string;
    /**
     * 操作类型('Like','Between','CompareColumn','CompareValue')默认为Null，表示为恒等
     */
    searchType: string;
}